export default {
  title: 'Uitverkochte artikelen',
  sections: {
    settings: 'Instellingen',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset:
          'Uitverkochte artikelen worden automatisch aan het einde van de dag weer als beschikbaar gemarkeerd.',
        manual_reset:
          'Personeel moet artikelen opnieuw als beschikbaar markeren nadat ze als uitverkocht zijn gemarkeerd.',
      },
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
